import { PlatformType, getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview } from '@nibfe/mkt-env-api';
import Navigate from '@nibfe/mkt-navigate-api';
import { navigateTo } from '@max/meituan-uni-navigate';
const { invokeJump } = Navigate;
const isMRN = false;
const isWeb = true;
import dayjs from 'dayjs';
export const getQueryParams = (ctx) => {
    const params = {};
    if (isWeb) {
        const queryString = window.location.search.substring(1);
        const queryArray = queryString.split('&');
        queryArray.forEach(query => {
            const [key, value] = query.split('=');
            params[key] = decodeURIComponent(value);
        });
        //  params['cityId'] = params['cityId'] || ctx._runtimeInfo.queryParams?.cityId;
    }
    console.log('params:========= ', isWeb, params);
    return params;
};
const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
// 跳民宿筛搜
export const onGoFilter = ({ cityId, clickBizLine, hotelchannel }) => {
    let query = `frontCityId=${cityId}`;
    if (hotelchannel) {
        query += `&hotelchannel=${hotelchannel}`;
    }
    if (clickBizLine) {
        query += `&clickBizLine=${clickBizLine}`;
    }
    const envokePoiDetailLink = convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/mrn?mrn_biz=zhenguo&mrn_entry=filter&mrn_component=zhenguo-filter&${query}`);
    if (isMeituanAppOrWebview()) {
        invokeJump(`imeituan://www.meituan.com/mrn?mrn_biz=zhenguo&mrn_entry=filter&mrn_component=zhenguo-filter&${query}`);
    }
    else if (isDianpingAppOrWebview()) {
        invokeJump(`dianping://mrn?mrn_biz=zhenguo&mrn_entry=filter&mrn_component=zhenguo-filter&${query}`);
    }
    else if (isWeixinMiniProgramOrWeixinWebview()) {
        const platformType = getPlatformType();
        const url = `/zhenguo/subpackage/products/laputa-filter/index?${query}`;
        switch (platformType) {
            case PlatformType.mtMinaWebview:
                navigateTo({
                    url,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            case PlatformType.mtHotelMinaWebview:
                navigateTo({
                    url: `/pages/navigator/index?appId=wxde8ac0a21135c07d&path=${encodeURIComponent(url)}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            default:
                navigateTo({
                    url: envokePoiDetailLink
                });
                break;
        }
    }
    else {
        navigateTo({
            url: envokePoiDetailLink
        });
    }
};
const getDate = () => {
    const now = dayjs();
    return {
        dateBegin: now.format('YYYYMMDD'),
        dateEnd: now.add(1, 'days').format('YYYYMMDD')
    };
};
export const onGoProductDetail = ({ productId, clickBizLine, hotelchannel }) => {
    const { dateBegin, dateEnd } = getDate();
    let query = `productId=${productId}&startDate=${dateBegin}&endDate=${dateEnd}`;
    if (hotelchannel) {
        query += `&hotelchannel=${hotelchannel}`;
    }
    if (clickBizLine) {
        query += `&clickBizLine=${clickBizLine}`;
    }
    const envokePoiDetailLink = convertLinkToAppMiddleOpenLink(`imeituan://www.meituan.com/mrn?mrn_biz=zhenguo&mrn_entry=product&mrn_component=zhenguo-product&${query}`);
    if (isMeituanAppOrWebview()) {
        invokeJump(`imeituan://www.meituan.com/mrn?mrn_biz=zhenguo&mrn_entry=product&mrn_component=zhenguo-product&${query}`);
    }
    else if (isDianpingAppOrWebview()) {
        invokeJump(`dianping://mrn?mrn_biz=zhenguo&mrn_entry=product&mrn_component=zhenguo-product&${query}`);
    }
    else if (isWeixinMiniProgramOrWeixinWebview()) {
        const url = `/zhenguo/pages/product/product?${query}`;
        const platformType = getPlatformType();
        switch (platformType) {
            case PlatformType.mtMinaWebview:
                navigateTo({
                    url,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            case PlatformType.mtHotelMinaWebview:
                navigateTo({
                    url: `/pages/navigator/index?appId=wxde8ac0a21135c07d&path=${encodeURIComponent(url)}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            default:
                navigateTo({
                    url: envokePoiDetailLink
                });
                break;
        }
    }
    else {
        console.log('==========else');
        navigateTo({
            url: envokePoiDetailLink
        });
    }
};
